function initMap() {


    var index = 0;

    $('.mcube-map').each(function() {



    // if ( $( "#map" ).length ) {
        $map = $(this);
        var lat = $map.data('lat');
        var lng = $map.data('lng');
        var zoom = $map.data('zoom');

        var mapStyle =
            [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#efefef"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#b5c3c8"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e0e4e6"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e0e4e6"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#2d5a68"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#aab9be"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#b5c3c8"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#215160"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#63848f"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#76929c"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                }
            ];



        // Single agences
        if ( lat && lng) {
            var map_agency = new google.maps.Map($map[0], {
            // var map_agency = new google.maps.Map(document.getElementById("map"), {
                center: new google.maps.LatLng(lat, lng),
                zoom: zoom,
                styles: mapStyle,
                mapTypeControl: false,
                scrollwheel: false,
                fullscreenControl: true,

            });

            new google.maps.Marker({
                position: { lat: parseFloat(lat), lng: parseFloat(lng) },
                map: map_agency,
                /*
                icon: {
                    // url: mcubeArgs.themeLink + "/svg/pointer.svg",
                    url: "/svg/pointer.svg",
                    scaledSize: new google.maps.Size(24, 30)
                }*/
            });
        }
        // Page contact
        else if ( window.agencies_json ) {
            var map_agencies = new google.maps.Map(document.getElementById("map"), {
                zoom: zoom,
                styles: mapStyle,
                mapTypeControl: false,
                scrollwheel: false,
                fullscreenControl: true,

            });
            var infowindow = new google.maps.InfoWindow();
            var bounds = new google.maps.LatLngBounds();

            $.each(window.agencies_json, function(key, agency) {
                marker = new google.maps.Marker({
                    position: { lat: parseFloat( agency.lat), lng: parseFloat( agency.lng) },
                    map: map_agencies,
                    icon: {
                        url: mcubeArgs.themeLink + "/svg/pointer.svg",
                        scaledSize: new google.maps.Size(24, 30)
                    }
                });

                bounds.extend(marker.position);

                google.maps.event.addListener(marker, 'click', (function (marker) {
                    return function() {
                        infowindow.setContent(agency.title);
                        infowindow.open(map_agencies, marker);
                    };
                })(marker));
            });

            map_agencies.fitBounds(bounds);
        }
        index++;
    });
}